{
  "brand": {
    "title": "SOR Registry",
    "description": "Enabling transparent and efficient carbon credit management for a sustainable future."
  },
  "support": {
    "title": "Support",
    "help_center": "Help Center",
    "contact_support": "Contact Support",
    "submit_ticket": "Submit Ticket",
    "system_status": "System Status"
  },
  "legal": {
    "title": "Legal",
    "privacy_policy": "Privacy Policy",
    "terms_of_service": "Terms of Service",
    "cookie_policy": "Cookie Policy",
    "disclaimer": "Disclaimer"
  },
  "connect": {
    "title": "Connect"
  },
  "copyright": "© Sovereign Offset Registry. All rights reserved."
}